import { z } from 'zod'

import { columnsSchema, requiredString } from '@/utils/zod'

export const studentCoursesFiltersSchema = z.object({
  course: z.array(z.string()).optional(),
  teacherOrCoTeacherId: z.array(z.string()).optional(),
  semester: requiredString().catch(''),
  ...columnsSchema.shape
})

export type StudentCoursesFiltersKey = keyof z.infer<
  typeof studentCoursesFiltersSchema
>
